import { render, staticRenderFns } from "./packagePrice.vue?vue&type=template&id=46fba27a&scoped=true"
import script from "./packagePrice.vue?vue&type=script&lang=js"
export * from "./packagePrice.vue?vue&type=script&lang=js"
import style0 from "./packagePrice.vue?vue&type=style&index=0&id=46fba27a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fba27a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fba27a')) {
      api.createRecord('46fba27a', component.options)
    } else {
      api.reload('46fba27a', component.options)
    }
    module.hot.accept("./packagePrice.vue?vue&type=template&id=46fba27a&scoped=true", function () {
      api.rerender('46fba27a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/price/packagePrice.vue"
export default component.exports